import React, { useState, useRef, useEffect } from 'react';
import Highlighter from 'react-multi-highlight';
import { Helmet } from 'react-helmet'
import './styles.css'
import 'text-encoding';
import 'bootstrap/dist/css/bootstrap.min.css';


function NewlineButton({ onClick, children, onMouseEnter, onMouseLeave }) {
  const buttonStyle = {
    fontSize: '18px',
    color: 'black',
    cursor: 'pointer',
    marginBottom: '5px',
    position: 'relative',
    zIndex: 1,
    transition: 'background-color 0.3s ease',
  };

  return (
    <div
      className="newline-button"
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={onMouseEnter} 
      onMouseLeave={onMouseLeave}  
    >
      {children}
    </div>
  );
}

function RightHalfUpper({ clauseTypes, highlightColors, onClick, onHover, hoveredClause, outputData }) {
  

  if (hoveredClause === null){
    return (
      <div className="righthalfupper-button-container">
        {Object.keys(clauseTypes).map((type, index) => (
          <div
            key={index}
            className="righthalfupper-button"
            style={{ 
              backgroundColor: highlightColors[type],}}
            onClick={() => onClick(type)}
            onMouseEnter={() => onHover(type)}
            onMouseLeave={() => onHover(null)}
          >
            {`${type} ${clauseTypes[type]}%`}
          </div>
        ))}
      </div>
    );
  } else{
  
  //const stringWithoutPeriod = hoveredClause.replace(/\.$/, '') //TO FIX!!!! YOU SHOULD BE INFERRING WITH THE PERIODS IN APP.PY!! 
  
  
  return (
    <div className="righthalfupper-button-container">
      {Object.keys(clauseTypes).map((type, index) => (
        <div
          key={index}
          className="righthalfupper-button"
          style={{ 
            backgroundColor: highlightColors[type],
            fontWeight: outputData[hoveredClause] === type ? 'bold': 'normal' }}
          onClick={() => onClick(type)}
          onMouseEnter={() => onHover(type)}
          onMouseLeave={() => onHover(null)}
        >
          {`${type} ${clauseTypes[type]}%`}
        </div>
      ))}
    </div>
  );
}}

const highlightColors = {
  'Termination condition': '#ff99cc',
  'Performance obligation': '#99ffcc',
  'Payment obligation': '#ffccff',
  'Compliance obligation': '#ffffcc',
  'Support or warranty obligation': '#ffcc99',
  'Insurance obligation': '#ffcccc',
  'Quality obligation': '#cc99ff',
  'Audit obligation': '#ccccff',
  'Contract renewal': '#99ccff',
  'Exceptions or exemptions': '#ccffff',
  'Indemnification': '#ccff99',
  'Jurisdiction': '#ccffcc',
  'None': 'white'
  // Add more clause types and colors as needed
};


function RightHalfLower({ outputText, outputData, highlightConfig, activeCategory, onBackButtonClick, onHover, onClauseClick }) {
  
  const handleClauseClick = (clause) => {
    const category = outputData[clause];
    if (onClauseClick) {
      onClauseClick(category);
    }
  };

  // Check if activeCategory is null
  if (activeCategory === null) {
    // Render the original outputText as is, splitting into different newline buttons
    return (
      <div>
        <div className="back-button-container">
          {activeCategory && (
            <button
              className="back-button"
              onClick={() => onBackButtonClick()}
            >
              ⬅️ Back
            </button>
          )}
        </div>

        
        <div>
          {Object.keys(outputData).map((key) => (
            <NewlineButton
              key={key}
              onMouseEnter={() => {
                onHover(key);
              }}
              onMouseLeave={() => {
                onHover(null);
              }}
              onClick={() => handleClauseClick(key)}
            >
              {
                <Highlighter
                  config={highlightConfig}
                  highlightTag="span"
                  normalTag="span"
                  text={key}
                />
              }
            </NewlineButton>
          ))}
        </div>



      </div>
    );
  } else {
    // Filter outputData based on activeCategory
    const filteredOutputData = Object.fromEntries(
      Object.entries(outputData).filter(([word, category]) => category === activeCategory)
    );

    // Display only the keys from filteredOutputData
    const filteredClauses = Object.keys(filteredOutputData);

    return (
      <div>
        <div className="back-button-container">
          {activeCategory && (
            <button
              className="back-button"
              onClick={() => onBackButtonClick()}
            >
              ⬅️ Back
            </button>
          )}
        </div>
        {filteredClauses.map((word, index) => (
          <NewlineButton key={index}>
            {
              <Highlighter
                config={highlightConfig}
                highlightTag="span"
                normalTag="span"
                text={word}
              />
            }
          </NewlineButton>
        ))}
      </div>
    );
  }
}



function App() {

  const defaultInputText = "THIS CONTRACT (“Contract”) is made and entered into by and between the State of Florida, Department of Commerce (“Commerce”) and Certified Roofing Specialist, Inc., (“Contractor”).  Commerce and Contractor are sometimes referred to herein individually as a “Party” and collectively as “the Parties.” \nI. \tCONTRACTOR AGREES: \nA.Attachment 1, Scope of Work: \nContractor agrees to provide the goods and/or services in accordance with the conditions and criteria specified herein, and in Attachment 1, Scope of Work.\nB.Type of Contract: \nThis Contract is a fixed price Contract.\nC.Contract Dates:\nThis Contract shall become effective on September 15, 2023, or the date of signature by both Parties and shall end on December 14, 2023.  Commerce shall not be obligated to pay for costs incurred related to this Contract prior to its beginning date or after its ending date. \nD.Contract Payment: \nThis Contract shall not exceed Three Hundred Fifteen Thousand, Two Hundred Ninety-Four Dollars and Zero Cents ($315,294.00) which shall be paid by Commerce in consideration for Contractor’s provision of goods and/or services as set forth by the terms and conditions of this Contract.  The State of Florida and Commerce’s performance and obligation to pay under this Contract is contingent upon an annual appropriation by the Legislature and availability of any and all applicable federal funds.  Commerce shall be the final authority as to the availability of funds for this Contract, and as to what constitutes an “annual appropriation” of funds to complete this Contract.  If such funds are not appropriated or available for the Contract purpose, such event will not constitute a default on Commerce or the State.  Commerce agrees to notify Contractor in writing at the earliest possible time if funds are not appropriated or available.  The cost for services rendered under any other Contract or to be paid from any other source is not eligible for reimbursement under this Contract.\nE.Requirements of paragraphs (a) – (i) of subsection 287.058(1), Florida Statutes (F.S.): \n1.  Contractor shall submit bills for fees or other compensation for services or expenses in \tsufficient detail for a proper pre-audit and post-audit thereof. \n2.  If travel expenses are authorized, Contractor shall submit bills for such travel expenses and \tshall be reimbursed only in accordance with section 112.061, F.S. \n\t \n3.  Contractor shall allow public access to all documents, papers, letters or other materials made or received by Contractor in conjunction with this Contract, unless the records are exempt from section 24(a) of Article I of the State Constitution and section 119.07(1), F.S.  It is expressly understood that Commerce may unilaterally cancel this Contract for Contractor’s refusal to comply with this provision. \n4. Contractor shall perform all tasks contained in Attachment 1, Scope of Work."

  const [inputText, setInputText] = useState(defaultInputText);
  const [outputText, setOutputText] = useState(''); //text just gives the raw block text to be displayed
  const [outputData, setOutputData] = useState({})
  const [activeCategory, setActiveCategory] = useState(null);
  const [hoveredClause, setHoveredClause] = useState(null);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [progress, setProgress] = useState(0);
  const [annotatedFile, setAnnotatedFile] = useState(null);
  const textareaRef = useRef();
  const fileInputRef = useRef(null);



  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    // Change the title
    document.title = 'Skim: Contract AI, LLM-powered';

    // Set the favicon (icon) to an emoji
    const favicon = document.getElementById('favicon');
    if (favicon) {
      // You can use any emoji here
      favicon.textContent = '🚀';
    }
  }, []);

  
  
  const handleButtonClick = (category) => {
    setActiveCategory(category);
  };

  const handleBackButtonClick = () => {
    setActiveCategory(null);
  };
  

  const handleGenerateClick = async () => {
    const url = 'https://skim-flask2-ejeubtakgscfdhgw.eastus-01.azurewebsites.net/api/generate_clause';
    let prevOutputData = {};
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                text: inputText,
            }),
        });

        // eslint-disable-next-line no-undef
        let decoder = new TextDecoderStream();
        if (!response.body) return;
        const reader = response.body
            .pipeThrough(decoder)
            .getReader();
        
        let buffer = ''; // To store the incomplete JSON string

        while (true) {
            var {value, done} = await reader.read();
            
            if (done) {
                break;
            } else {
                buffer += value;
                const jsonStrings = buffer.split('*****');

                for (let i = 0; i < jsonStrings.length - 1; i++) {
                    const jsonString = jsonStrings[i].trim();
                    if (jsonString) {
                        const incoming_addition = JSON.parse(jsonString);
                        // Update the previous state with the merged data
                        prevOutputData = Object.assign({}, prevOutputData, incoming_addition.lookup);
                        setOutputData(prevOutputData);
                        setProgress(incoming_addition.progress);
                    }
                }

                buffer = jsonStrings[jsonStrings.length - 1]; // Save the last incomplete JSON string
            }
        }

        // Handle the last part of the buffer if it contains a valid JSON
        if (buffer.trim()) {
            const incoming_addition = JSON.parse(buffer);
            prevOutputData = Object.assign({}, prevOutputData, incoming_addition.lookup);
            setOutputData(prevOutputData);
            setProgress(incoming_addition.progress);
        }

    } catch (error) {
        console.log(error);
    }
  };

  const handleImportClick = async () => {
    
    if (selectedFile){
      const formData = new FormData();
      formData.append('file', selectedFile)
      const url = 'https://skim-flask2-ejeubtakgscfdhgw.eastus-01.azurewebsites.net/api/file_generate_clause';
      var tmpPromptResponse = '';
      let prevOutputData = {};
      try {
        setOutputData({})
        const response = await fetch(url , {
          method: 'POST',
          headers: {
            // don't set content type, will automatically be set
          },
          body: formData
        });
        
        // eslint-disable-next-line no-undef
        let decoder = new TextDecoderStream();
        if (!response.body) return;
        const reader = response.body
          .pipeThrough(decoder)
          .getReader();
        
        while (true) {
          var {value, done} = await reader.read();
          
          if (done) {
            break;
          } else { //if not done receiving all the data, read whatever has been sent so far
            console.log(value);
            const jsonStrings = value.split('*****')
            console.log(jsonStrings)

            for (const jsonString of jsonStrings){
              if (jsonString.trim() === '') continue; //Skip empty strings
            
              const incoming_addition = JSON.parse(jsonString);
              // Update the previous state with the merged data
              prevOutputData = Object.assign({}, prevOutputData, incoming_addition.lookup);
              setOutputData(prevOutputData)
              setProgress(incoming_addition.progress);
            }
          }
        }


        // now, post the tmpPromptResponse back to flask for annotate_file, which annotates the file with python-docx and sends it back down

        try {
          console.log(outputData)
          formData.append('outputData_sendback', JSON.stringify(outputData));
          const sendback_url = 'https://skim-flask2-ejeubtakgscfdhgw.eastus-01.azurewebsites.net/api/annotate_file';
          const sendback_response = await fetch(sendback_url, {
            method: 'POST',
            headers: {
            },
            body: formData,
          });

          // sendback_response should be a readily readable docx file.

          // Assuming the response is a Blob representing the annotated file
          const annotatedBlob = await sendback_response.blob();
          setAnnotatedFile(annotatedBlob);

        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.log(error);
      }
    
    }

  };



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  }

  const handleDownloadAnnotatedFile = () => {
    // Check if the annotatedFile is available
    if (annotatedFile) {
      // Create a Blob URL for the annotated file
      const url = window.URL.createObjectURL(annotatedFile);

      // Create a link element and trigger a download
      const link = document.createElement('a');
      link.href = url;
      link.download = 'annotated_document.docx';
      document.body.appendChild(link);
      link.click();

      // Remove the link element
      document.body.removeChild(link);
    }
  };

  useEffect(() => { 
    adjustTextareaHeight(); // When the conditions in the function adjustTextareaHeight are met (ie. the height of the textbox exceeds the div), adjust the text area height
    window.addEventListener('resize', adjustTextareaHeight); // When the browser window gets resized, adjust the text area height similarly

    return () => {
      window.removeEventListener('resize', adjustTextareaHeight); // Cleanup function
    };
  }, [inputText]);

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      const maxHeight = window.innerHeight - textareaRef.current.offsetTop - 80; // Adjust for padding/margin and button height
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, maxHeight)}px`;
    }
  };

  const highlightColors = {
    'Termination condition': '#ff99cc',
    'Performance obligation': '#99ffcc',
    'Payment obligation': '#ffccff',
    'Compliance obligation': '#ffffcc',
    'Support or warranty obligation': '#ffcc99',
    'Insurance obligation': '#ffcccc',
    'Quality obligation': '#cc99ff',
    'Audit obligation': '#ccccff',
    'Contract renewal': '#99ccff',
    'Exceptions or exemptions': '#ccffff',
    'Indemnification': '#ccff99',
    'Jurisdiction': '#ccffcc',
    'None': 'white'
    // Add more clause types and colors as needed
  };

  const boldHovereds = {
    true : 'bold'
  }

  const highlightConfig = Object.keys(outputData).flatMap((key) => {
    const category = outputData[key];
  
    return {
      word: key,
      className: 'highlight',
      style: {
        backgroundColor: highlightColors[category], // 
        fontWeight: hoveredCategory === category ? 'bold' : 'normal'
      },
    };
  });

  // Calculate clause types and percentages
  const calculateClauseTypes = () => {
    const clauseTypes = {};
    const totalClauses = Object.keys(outputData).length;

    Object.keys(outputData).forEach((key) => {
      const category = outputData[key];
      clauseTypes[category] = (clauseTypes[category] || 0) + 1;
    });

    // Calculate percentages
    Object.keys(clauseTypes).forEach((type) => {
      clauseTypes[type] = ((clauseTypes[type] / totalClauses) * 100).toFixed(0);
    });

    return clauseTypes;
  };

  const clauseTypes = calculateClauseTypes();

  
  return (
    <div style={appStyle}>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
        />
      </Helmet>

      <header style={headerStyle}>
        <div>SKIM</div>
        <div style={subtitleStyle}>
          { (progress < 1) & (progress != 0) ? (
            <div style={{ fontSize: '20px', fontWeight: 'normal' }}>
              👩🏻‍💻 processing... {Math.round(progress * 100)}%
            </div>
          ) : (
            <div style={{ fontSize: '20px', fontWeight: 'normal' }}>
              quick and intelligent clause extraction
            </div>
          )}
        </div>
      </header>

      <div className="content-container">
        <div className="left-half" style={leftHalfStyle}>
          <div style={textareaContainerStyle}>
            <textarea
              ref={textareaRef}
              rows="1"
              value={inputText}
              onChange={(event) => setInputText(event.target.value)}
              style={textInputStyle}
            />
          </div>
          <br />
          <div className="container mt-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <button className="btn btn-primary btn-lg w-100" onClick={handleGenerateClick}>
                  Find clause type
                </button>
              </div>
              <div className="col-md-6 mb-3">
                <button className="btn btn-secondary btn-lg w-100" onClick={handleImportClick}>
                  Process word doc
                </button>
                <input
                  type="file"
                  accept=".docx"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  className="form-control mt-2"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="right-half" style={rightHalfStyle}>
          <div style={righthalfUpperStyle}>
            {/* Right Half Upper */}
            <RightHalfUpper 
              clauseTypes={clauseTypes} 
              highlightColors={highlightColors} 
              onClick={handleButtonClick} 
              onHover={(category) => setHoveredCategory(category)}
              hoveredClause={hoveredClause}
              outputData={outputData}
            />
          </div>

          {/* Line Divider */}
          <div style={{ borderTop: '1px solid #ccc', margin: '10px 0' }} />

          <div style={righthalfLowerStyle}>
            {/* Right Half Lower */}
            <RightHalfLower 
              outputText={outputText} 
              outputData={outputData} 
              highlightConfig={highlightConfig} 
              activeCategory={activeCategory} 
              onBackButtonClick={handleBackButtonClick}
              hoveredCategory={hoveredCategory}
              onHover={(clause) => setHoveredClause(clause)}
              onClauseClick={(category) => setActiveCategory(category)}
            />
          </div>
        </div>
      </div>
    </div>
  );

}



const appStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100vh',
  overflow: 'auto',
};

const leftHalfStyle = {
  flex: 1,
  textAlign: 'center',
  marginLeft: '100px',
  marginRight: '100px',
};

const rightHalfStyle = {
  flex: 1,
  whiteSpace: 'pre-wrap',
  fontFamily: 'Roboto, sans-serif',
  marginRight: '50px',
};

const righthalfUpperStyle = {
  flex: 1,
  whiteSpace: 'pre-wrap',
  fontFamily: 'Roboto, sans-serif',
  display: 'flex',
  flexDirection: 'row',
};

const righthalfLowerStyle = {
  flex: 1,
  whiteSpace: 'pre-wrap',
  fontFamily: 'Roboto, sans-serif',
  marginRight: '0px',
  overflowY: 'auto',
  maxHeight: '60vh',
};

///////////////////

// Custom styles for the app

// Custom styles for the textarea container
const textareaContainerStyle = {
  marginBottom: '10px', // Adjust margin to separate textarea and button
};

// Custom styles for the textarea
const textInputStyle = {
  width: '100%',
  padding: '10px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  fontSize: '18px', // Increased font size
  fontFamily: 'Roboto, sans-serif',
  overflowY: 'auto', // Use vertical scrollbar when content exceeds maxHeight
  resize: 'none', // Disable textarea resizing handle
  maxHeight: 'calc(100vh - 350px)', // Adjust for header height and button height -> is dummy set right now, note if you're changing other parameters
};


// Custom styles for the header
const headerStyle = {
  fontFamily: 'Century',
  fontSize: '50px',
  fontWeight: 'bold',
  textAlign: 'center',
  margin: '20px 0',
};

// Custom styles for the subtitle
const subtitleStyle = {
  fontSize: '20px',
  fontWeight: 'normal',
  fontFamily: 'Roboto, sans-serif',
};

// Custom styles for the content container
const contentContainerStyle = {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-around',
  flexGrow: 1
};


// Custom styles for the left half


// Custom styles for the right half






export default App;
